import axios from 'axios'

export const purchase = {
  namespaced: true,
  state: {
    detail: {},
    tickets: [],
    promoter_newsletter: false,
    promoter_terms: false,
    list: {}
  },

  mutations: {
    setDetail(state, detail) {
      state.detail = detail
    },
    setList(state, list) {
      state.list = list
    },
    setTickets(state, tickets) {
      state.tickets = tickets
    },
    cleanTickets(state) {
      state.tickets = []
    },
    updatePromoterNewsletter(state, value) {
      state.promoter_newsletter = value
    },
    updatePromoterTerms(state, value) {
      state.promoter_terms = value
    }
  },

  actions: {
    async create({ commit }, payload) {
      await axios
        .post('/purchases/', payload)
        .then(res => {
          commit('setDetail', res.data)
        })
        .catch(res => {
          if (typeof window !== 'undefined') {
            var event
            if (res.status === 409) {
              if (typeof CustomEvent === 'function') {
                event = new CustomEvent('showError', {
                  detail: {
                    text: 'Los tickets seleccionados ya no están disponibles'
                  }
                })
                window.dispatchEvent(event)
              }
            } else if (res.status !== 401) {
              if (typeof CustomEvent === 'function') {
                event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    async createSeatsio({ commit }, payload) {
      await axios
        .post('/seatsio/purchases/', payload)
        .then(res => {
          commit('setDetail', res.data)
        })
        .catch(res => {
          if (typeof window !== 'undefined') {
            if (typeof CustomEvent === 'function') {
              var event = new CustomEvent('showError', {
                detail: {
                  textI18N: 'error.title',
                  error: res
                }
              })
              window.dispatchEvent(event)
            }
          }
        })
    },
    async detail({ commit }, payload) {
      await axios.get(`/purchases/${payload.reference}/`).then(res => {
        commit('setDetail', res.data)
      })
    },
    setTickets({ commit }, payload) {
      commit('setTickets', payload)
    },
    cleanTickets({ commit }, payload) {
      commit('cleanTickets', payload)
    },
    setPromoterNewsletter({ commit }, payload) {
      commit('updatePromoterNewsletter', payload)
    },
    setPromoterTerms({ commit }, payload) {
      commit('updatePromoterTerms', payload)
    }
  }
}
